// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3o4CL","emails":"CreateEditClinics_emails__2pqUZ","emailTagLabel":"CreateEditClinics_emailTagLabel__2x77y"};